export const getGoogleIdFromCookies = () => {
  let gaClientId1 = document.cookie
    ?.split('; ')
    ?.filter((row) => row.startsWith('_ga'))
    .map((c) => c.split('=')[1])[0]
  gaClientId1 = gaClientId1 ? gaClientId1.split('.')[2] : ''
  let gaClientId2 = document.cookie
    ?.split('; ')
    ?.filter((row) => row.startsWith('_ga'))
    .map((c) => c.split('=')[1])[0]
  gaClientId2 = gaClientId2 ? gaClientId2.split('.')[3] : ''
  const gaSessionProd = document.cookie
    ?.split('; ')
    ?.filter((row) => row.startsWith('_ga_0L54PEG9PK'))
    .map((c) => c.split('=')[1])[0]
  const gaSessionStaging = document.cookie
    ?.split('; ')
    ?.filter((row) => row.startsWith('_ga_JEXW3CNLMH'))
    .map((c) => c.split('=')[1])[0]
  let gaSession = gaSessionProd || gaSessionStaging
  gaSession = gaSession ? gaSession.split('.')[2] : ''
  return {
    clientId: `${gaClientId1}.${gaClientId2}`,
    sessionId: `${gaSession}`,
  }
}
